import { render, staticRenderFns } from "./Bases.vue?vue&type=template&id=53b36c41&scoped=true&"
import script from "./Bases.vue?vue&type=script&lang=js&"
export * from "./Bases.vue?vue&type=script&lang=js&"
import style0 from "./Bases.vue?vue&type=style&index=0&id=53b36c41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b36c41",
  null
  
)

export default component.exports